import React from 'react';
import { Podcast } from 'Components/molecules/Podcast';

export const getPodcast = podcastData => (
  <Podcast {...podcastData} />
);
